import { StrictEqualityComparer } from "../../shared/index.js";
import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const distinct = (source, comparer = StrictEqualityComparer) => {
    async function* iterator() {
        const distinctElements = [];
        for await (const item of source) {
            const foundItem = distinctElements.find((x) => comparer(x, item));
            if (!foundItem) {
                distinctElements.push(item);
                yield item;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
